export default "__VITE_ASSET__d5cf7978__"